import ko from 'knockout';
import _ from 'underscore';
import { AppInstallAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import * as schemaMapper from '@bingads-webui-campaign-legacy/crud-ad/schemaMapper';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const appPlatformKeys = {
  'Android': i18n.get('AppInstall_Platform_Android'),
  'iOS': i18n.get('AppInstall_Platform_iOS'),
  'Windows Phone': i18n.get('AppInstall_Platform_WinPhone'),
  'Windows': i18n.get('AppInstall_Platform_Windows'),
};

const previewTabItems = {
  Mobile: 'MobileView',
  Tablet: 'TabletView',
};

export default class {
  constructor({
    model = null,
    appLookupDisabled = false,
    developerName = '',
    defaultLandingPageUrl = '',
    activityLogger,
  } = {}) {
    this.tabItems = previewTabItems;
    this.upgradedUrlFields = _.compact(['FinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix']);
    this.schemaFields = schemaMapper.AppInstall(); // eslint-disable-line
    this.activityLogger = activityLogger;

    const customValidations = {
      AppStoreId: {
        isValid: (value) => {
          if (ko.unwrap(this.AppPlatform) === 'iOS' && value) {
            return (/^\d+$/i).test(value);
          }

          return true;
        },
        message: i18n.get('AppInstall_Validation_Digit_Only'),
      },
    };

    this.fields = _.difference(this.schemaFields, ['DestinationUrl']);

    koSchema.properties(this, AppInstallAd, this.fields, _.defaults(model || {}, { DestinationUrl: defaultLandingPageUrl }), customValidations);

    const appPlatformsEnum = AppInstallAd.properties.AppPlatform.enum;

    this.appPlatforms = _.map(appPlatformsEnum, (key) => {
      return {
        Name: appPlatformKeys[key],
        Value: key,
      };
    });

    this.editMode = ko.observable(!_.isEmpty(model));
    this.appLookupDisabled = ko.observable(appLookupDisabled);
    this.developerName = ko.observable(developerName);
    this.appSelected = ko.observable(this.editMode());
    this.previewType = ko.observable(this.tabItems.Mobile);

    this.manualApp = ko.computed(() => {
      return this.AppStoreId() && !(this.AltText() || this.MediaUrl()); // eslint-disable-line
    });

    this.appIdPlaceholderText = ko.computed(() => {
      return this.manualApp() ? this.AppStoreId() : i18n.get('AppLookup_SearchBoxPlaceHolderTerm'); // eslint-disable-line
    });

    this.appIdName = ko.computed(() => {
      if(this.AppPlatform() === 'Android') { // eslint-disable-line
        return i18n.get('AppInstall_Package_Name');
      }

      return i18n.get('AppInstall_App_Id');
    });

    this.appStoreIdPlaceholderText = ko.computed(() => {
      if(this.AppPlatform() === 'Android') { // eslint-disable-line
        return i18n.get('AppInstallAd_Placeholder_PackageName_Android');
      } else if (this.AppPlatform() === 'iOS') { // eslint-disable-line
        return i18n.get('AppInstallAd_Placeholder_PackageName_iOS');
      }

      return i18n.get('AppInstallAd_Placeholder_PackageName_Windows');
    });

    this.adTitlePreview = ko.computed(() => {
      return !_.isEmpty(this.Title()) ? this.Title() : i18n.get('AppInstall_Title'); // eslint-disable-line
    });

    this.appStorePreview = ko.computed(() => {
      var appStoreName = this.AppPlatform() && this.AppStoreId() ? i18n.get('AppInstall_AppStore_' + this.AppPlatform().replace(' ', '_')) : ''; // eslint-disable-line
      return appStoreName ? i18n.get('AppInstall_Preview_AppStore_New', { name: appStoreName }) : i18n.get('Ad_Preview_Default');
    });

    this.adTextPreview = ko.computed(() => {
      return !_.isEmpty(this.Text())? this.Text() : i18n.get('AppInstall_Text'); // eslint-disable-line
    });

    this.previewUrl = ko.computed(() => {
      return _.first(this.FinalUrls()); // eslint-disable-line
    });

    _.each(this.fields, (field) => {
      // log once per field.
      const logChange = _.once(() => {
        if (this.activityLogger) {
          this.activityLogger.signal(`ad field change: ${field}`, 'app install ad editor');
        }
      });

      this[field].subscribe(() => {
        logChange();
      });
    });
  }

  previewTabSelected(type) {
    return this.previewType() === type ? 'ui-tabs-selected' : 'preview-tabs-unselected';
  }
}
